var React = require('react');

function Dashboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.501 1.563h4.024a.94.94 0 01.939.938v2.414a.94.94 0 01-.94.94H2.502a.94.94 0 01-.938-.94V2.501a.94.94 0 01.938-.938zm0 5.364h4.024a.94.94 0 01.939.939v5.633a.94.94 0 01-.94.938H2.502a.94.94 0 01-.938-.938V7.866a.94.94 0 01.938-.939zM13.5 10.146H9.475a.94.94 0 00-.939.939v2.414a.94.94 0 00.94.938h4.023a.94.94 0 00.938-.938v-2.414a.94.94 0 00-.938-.94zM9.475 1.562H13.5a.94.94 0 01.938.94v5.632a.94.94 0 01-.938.939H9.475a.94.94 0 01-.939-.939V2.501a.94.94 0 01.94-.938z"}));
}

Dashboard.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Dashboard;

Dashboard.default = Dashboard;
